import React from 'react';
import { Link } from "react-router-dom";
import { toast, ToastContainer, Zoom } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css"
import logo from '../img/logo/hyundaimobis_CI.png'

function Menu() {

    return (
        <>
            <ToastContainer draggable={false} transition={Zoom} autoClose={3000} style={{ width: "100%", textAlign: "center", fontSize: "100%" }} hideProgressBar />
            <div className="min-h-[calc(100vh)] flex flex-col items-center justify-center login-bg" >
                <div className="flex flex-col bg-white shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-md w-full max-w-md">
                    <img src={logo} alt="Logo" />
                    <div className="relative mt-10 h-px bg-gray-300" />
                    <div className="mt-5">
                        <div className="flex flex-wrap w-full">
                            <Link to="mes"
                                className="flex items-center justify-center m-1 focus:outline-none text-white text-sm sm:text-base bg-blue-600 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in">
                                <span className="mr-2 uppercase">Alabama</span>
                                <span>
                                    <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </span>
                            </Link>
                            <Link to="mesga"
                                className="flex items-center justify-center m-1 focus:outline-none text-white text-sm sm:text-base bg-blue-600 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in">
                                <span className="mr-2 uppercase">Georgia</span>
                                <span>
                                    <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </span>
                            </Link>
                            <Link to="bsa1"
                                className="flex items-center justify-center m-1 focus:outline-none text-white text-sm sm:text-base bg-blue-600 hover:bg-blue-700 rounded py-2 w-full transition duration-150 ease-in">
                                <span className="mr-2 uppercase">BSA 1</span>
                                <span>
                                    <svg className="h-6 w-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Menu;
